import { Transition }               from '@uirouter/core';

import { ApiService }   from '../api/api.service';
import { TableService } from '../table/table.service';

import { LoanCarActivateComponent }  from './loan-car-schedule.activate.component';
import { LoanCarScheduleComponent } from './loan-car-schedule.component';
import { LoanVehiclesComponent }    from './loan-car-schedule.vehicles.component';

export const LoanCarScheduleStates : Array<any> = [
  {
    component: LoanCarScheduleComponent,
    name     : 'app.loan-car',
    params   : {
      customer_id: { squash: true, value: null }
    },
    url: '/loanCar/:customer_id?view&group_index&date&loanVehicle&loanVehicleId&viewSingleLoanVehicle',
    resolve    : [
      {
        token    : 'customer',
        deps     : [ Transition, ApiService ],
        resolveFn: ( transition : Transition, apiService : ApiService ) : Promise<any> | Array<any> =>
          transition.params().customer_id
            ? apiService.get('/customer', transition.params().customer_id)
            : []
      },
      {
        token    : 'groups',
        deps     : [ Transition, ApiService ],
        resolveFn: ( transition : Transition, apiService : ApiService ) : Promise<any> =>
          apiService.get('/system/loan_vehicle_grouping_for_filter', transition.params().view === 'multiColAgendaDay' ? '5' : '10')
      },
      {
        token    : 'settings',
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : Promise<any> => apiService.get('/company')
      },
      {
        token    : 'states',
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : Promise<any> => apiService.get('/system/state_types', null, 'states')
      }
    ]
  },
  {
    component : LoanCarActivateComponent,
    name      : 'app.loan-car-activate',
    url       : '/loan_car/activate',
    resolve    : [
      {
        token    : 'settings',
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : Promise<any> => apiService.get('/company')
      }
    ]
  },
  {
    component: LoanVehiclesComponent,
    name     : 'app.loan-vehicles',
    url      : '/loanVehicles',
    resolve    : [
      {
        token    : 'loan_vehicles',
        deps     : [ TableService, ApiService ],
        resolveFn: ( tableService : TableService, apiService : ApiService ) : Promise<any> => {
          const cache = tableService.getCacheForTable('loanVehicles');

          return apiService.stream('/filters', [
            '*',
            'loan_vehicles',
            0,
            cache.paging.pageSize   || 10,
            cache.sorting.field     || 'plate_number',
            cache.sorting.direction || 'asc',
            false
          ]);
        }
      }
    ]
  }
];
